import { BASE_RESOURCE, brandType, bronsonBrand } from '../../config';

export const getPages = () =>
  import(`../../resources/${brandType}/pages/index.json`).catch(
    () => import(`../../resources/${BASE_RESOURCE}/pages/index.json`)
  );

export const getModels = () =>
  import(`../../resources/${brandType}/models`).catch(() => import(`../../resources/${BASE_RESOURCE}/models`));

export const getStyles = () =>
  import(`@vwfs-bronson/bronson-${bronsonBrand}/dist/css/style.min.css`).then(() => import('../../styles.scss'));

export const getLogosSrc = async () => {
  let logoDefault;
  let logoSmall;

  switch (brandType) {
    case 'skoda':
    case 'vw':
      logoDefault = await import(`@vwfs-bronson/bronson-${bronsonBrand}/dist/img/logo.png`);
      logoSmall = await import(`@vwfs-bronson/bronson-${bronsonBrand}/dist/img/logo-small-screen.png`);

      return {
        logoDefault: logoDefault.default,
        logoSmall: logoSmall.default,
      };
    case 'vw6':
    case 'seat':
    case 'audi':
      logoDefault = await import(`@vwfs-bronson/bronson-${bronsonBrand}/dist/img/logo.svg`);

      return {
        logoDefault: logoDefault.default,
        logoSmall: logoDefault.default,
      };
    case 'vwfs':
      logoDefault = await import(`@vwfs-bronson/bronson-${bronsonBrand}/dist/img/logo.svg`);
      logoSmall = await import(`@vwfs-bronson/bronson-${bronsonBrand}/dist/img/logo-small-screen.svg`);

      return {
        logoDefault: logoDefault.default,
        logoSmall: logoSmall.default,
      };
    case 'vwcv':
    default:
      logoDefault = await import(`@vwfs-bronson/bronson-${bronsonBrand}/dist/img/logo.png`);
      logoSmall = await import(`@vwfs-bronson/bronson-${bronsonBrand}/dist/img/logo-small-screen.png`);

      return {
        logoDefault: logoDefault.default,
        logoSmall: logoSmall.default,
      };
  }
};
